import React from 'react'
import { Header } from '../Header'
import { Footer } from '../Footer'
import { FlashMessage } from './FlashMessage'
import { GlobalLoading } from './GlobalLoading'


interface AvoRedAppProps {
    children: React.ReactNode
  }

  

export const AvoRedApp = (props: AvoRedAppProps) => {
  return (
    <div className='antialiased flex flex-col min-h-screen'>
        <Header />
        <FlashMessage />
        <GlobalLoading />
        <main className="flex-grow">
          {props.children}
        </main>
        <Footer />
    </div>
  )
}
